import { Component, OnInit, Inject } from '@angular/core';

import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TenantDeleteDialogService } from './TenantDeleteDialogService';
import { AbstractComponent } from 'src/core/common/component/AbstractComponent';

@Component({
  selector: 'gs-tenant-delete-dialog',
  templateUrl: './TenantDeleteDialog.html',
  styleUrls: ['./TenantDeleteDialog.scss'],
})
export class TenantDeleteDialogComponent extends AbstractComponent {
  public scope = {
    title: '',
    error: false,
    nameConfirm: '',
    item: { tenantName: '' },
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public parameter: any,
    private matDialogRef: MatDialogRef<TenantDeleteDialogComponent>,
    private dialog: MatDialog) {
    super();
    this.scope.item = parameter;
    console.log(parameter);
  }

  public onSubmit() {
    if (this.scope.item.tenantName == this.scope.nameConfirm) {
      this.matDialogRef.close({
        status: 'SUCCESS',
      });
    }
    this.scope.error = true;
  }
}
